export default __webpack_public_path__ + "assets/i18n/app/en.4aeeeb61fd26b2ed9f3960bc178cd9b2.json";